// API
const headers = {
  "Content-Type": "application/graphql",
  "X-Shopify-Storefront-Access-Token": "eb01531c2dbd30a0e8b5162ff6a625e4",
};

// Queries
const PRODUCT_QUERY = `
  availableForSale
  id
  title
  description(truncateAt: 80)
  handle
  tags
  productType
  options {
    name,
    values
  }
  featuredImage {
    src
    height
    width
  }
  images(first: 20) {
    edges {
      node {
        altText
        url
      }
    }
  }
  priceRange {
    maxVariantPrice {
      amount
    }
    minVariantPrice {
      amount
    }
  }
  variants(first: 250) {
    edges {
      node {
        id
        availableForSale
        compareAtPrice {
          amount
        }
        price {
          amount
        }
        title
        selectedOptions {
          value
          name
        }
      }
    }
  }
  vendor
  metafield(key: "location", namespace: "information") {
    value
  }
`;

// Product Mutation
function transformGraphqlProduct(productNode) {
  if (!productNode) {
    return null;
  }

  const variants = productNode.variants.edges.map(({ node }) => {
    return {
      id: parseInt(node.id.replace("gid://shopify/ProductVariant/", "")),
      available: node.availableForSale,
      compare_at_price: node.compareAtPrice?.amount || null,
      options: node.selectedOptions.map((option) => option.value),
      option1: node.selectedOptions[0].value,
      price: node.price?.amount || null,
      title: node.selectedOptions[0].value,
    };
  });

  const options = productNode.options.map((option) => option.name);
  const options_with_values = productNode.options.map((option) => {
    return {
      name: option.name,
      position: productNode.options.indexOf(option) + 1,
      title: option.values,
    };
  });

  return {
    objectType: "product",
    available: productNode.availableForSale,
    handle: productNode.handle,
    url: `/products/${productNode.handle}`,
    id: parseInt(productNode.id.replace("gid://shopify/Product/", "")),
    tags: productNode.tags.map((tag) => tag.toLowerCase()),
    productType: productNode.productType,
    title: productNode.title,
    description: productNode.description,
    variants,
    price: productNode.priceRange.minVariantPrice.amount.replace(".", ","),
    compare_at_price: productNode.variants.edges[0].node.compareAtPrice.amount === productNode.variants.edges[0].node.price.amount ? '' : productNode.variants.edges[0].node.compareAtPrice.amount,
    // compare_at_price: productNode.variants.edges[0].node.compareAtPrice?.amount.replace(".", ",") || null,

    featured_image: productNode.featuredImage,
    images: productNode.images.edges.map((image) => image.node.url),
    metafield: productNode.metafield?.value,
    has_only_default_variant: productNode.options[0].values[0] === "Default Title",
    options,
    vendor: productNode.vendor,
    ...(productNode.options[0] && { option1: productNode.options[0].name }),
    ...(productNode.options[1] && { option2: productNode.options[1].name }),
    ...(productNode.options[2] && { option3: productNode.options[2].name }),
    options_with_values,
  };
}

// Handlebar Helpers

Handlebars.registerHelper("compare", function (a, operator, b, options) {
  var bool = false;

  switch (operator) {
    case "==":
      bool = a == b;
      break;
    case "===":
      bool = a === b;
      break;
    case "!=":
      bool = a != b;
      break;
    case "!==":
      bool = a !== b;
      break;
    case "<":
      bool = a < b;
      break;
    case "<=":
      bool = a <= b;
      break;
    case ">":
      bool = a > b;
      break;
    case ">=":
      bool = a >= b;
      break;
    default:
      throw "Unknown operator " + operator;
  }

  return bool ? options.fn(this) : options.inverse(this);
});

Handlebars.registerHelper("hasFlag", function (tags, flag, options) {
  if (tags) {
    for (let i = 0; i < tags.length; i++) {
      if (tags[i].startsWith(flag + "|")) {
        const text = tags[i].split("|")[1].replace(/-/g, " ");
        return options.fn({ text });
      }
    }
  }
  return options.inverse(this);
});

// End Handlebar Helpers